import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import Goldman from '../../images/projects-slider/goldman-bangalore.webp';
import Goldman2 from '../../images/Project_Images/Goldman_building.webp';
import Goldman3 from '../../images/Project_Images/Goldman_4.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function Acousticgold() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    return (

        <>
            <Helmet>
                <title>About Our Goldman Sachs Acoustics Project </title>
                <meta name="description" content="" />
                <meta property="og:title" content="Goldman Sachs" />
                <meta property="og:description" content="Acoustic Wall Treatment." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/projects-slider/goldman-bangalore.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/project-goldman-sachs" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/project-goldman-sachs" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={Goldman} className="img-fluid" alt="Goldman Sachs" />
                                            </div>
                                            <div className="slide">
                                                <img src={Goldman2} className="img-fluid" alt="Goldman Sachs" />
                                            </div>
                                            <div className="slide">
                                                <img src={Goldman3} className="img-fluid" alt="Goldman Sachs" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Goldman Sachs </h3>
                                    <p className="note">Location: Bangalore</p>
                                    <p><strong>About Goldman Sachs</strong>
                                        <br />The Goldman Sachs Group, Inc. is a leading global investment banking, securities and investment management firm that provides a wide range of financial services to a substantial and diversified client base that includes corporations, financial institutions, governments and individuals. Founded in 1869, the firm is headquartered in New York and maintains offices in all major financial centres around the world.<br />
                                    </p>
                                    <p>
                                        <strong>Our Scope</strong>
                                        <br />Our scope includes comprehensive acoustic wall treatments tailored to enhance the acoustic quality and aesthetics of Goldman Sachs' global offices. From consultation to installation, we ensured Topnotch sound control solutions.
                                    </p><br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default Acousticgold;